import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function IAAlertForm() {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    artist: "",
    medium: "huile",
    type: "vente_recommandee",
    message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { error } = await supabase.from("ia_alerts").insert([{ ...form }]);
    if (error) {
      setStatus({ success: false, message: t("artistQuoteTools.iaAlert.error", { message: error.message }) });
    } else {
      setStatus({ success: true, message: t("artistQuoteTools.iaAlert.saved") });
      setForm({ artist: "", medium: "huile", type: "vente_recommandee", message: "" });
    }
  };

  return (
    <div className="max-w-xl">
      <h3 className="text-xl font-semibold mb-4">📢 {t("artistQuoteTools.iaAlert.title")}</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          name="artist"
          value={form.artist}
          onChange={handleChange}
          placeholder={t("artistQuoteTools.common.artistPlaceholder")}
          required
        />

        <select name="medium" value={form.medium} onChange={handleChange} className="form-control-artsy">
          {["huile", "aquarelle", "dessin", "sculpture"].map((key) => (
            <option key={key} value={key}>{t(`artistQuoteTools.mediums.${key}`)}</option>
          ))}
        </select>

        <select name="type" value={form.type} onChange={handleChange} className="form-control-artsy">
          {["vente_recommandee", "hausse_cote", "baisse_cote"].map((key) => (
            <option key={key} value={key}>{t(`artistQuoteTools.iaAlert.types.${key}`)}</option>
          ))}
        </select>

        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          placeholder={t("artistQuoteTools.iaAlert.messagePlaceholder")}
          className="w-full border rounded p-2 min-h-[100px]"
          required
        />

        <Button type="submit">📤 {t("artistQuoteTools.iaAlert.save")}</Button>

        {status && (
          <p className={`text-sm ${status.success ? "text-green-600" : "text-red-600"}`}>
            {status.message}
          </p>
        )}
      </form>
    </div>
  );
}
